import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export type HomeIconProps = SvgIconProps

export function HomeIcon(props: HomeIconProps) {
  const { htmlColor } = props
  return (
    <SvgIcon width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Home">
        <g>
          <g id="XMLID_00000007425879667070358340000014740525674215604407_">
            <g>
              <polygon
                style={{ fill: htmlColor || '#A7A9AC' }}
                points="162.268,105.889 162.268,177.459 115.828,177.459 115.828,136.749 83.938,136.749 
					83.938,177.459 37.498,177.459 37.498,105.889 99.858,50.109 				"
              />
            </g>
            <g>
              <polygon
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                points="99.858,50.109 37.498,105.889 37.498,177.459 83.938,177.459 83.938,136.749 115.828,136.749 115.828,177.459 162.268,177.459 162.268,105.889"
              />
              <polyline
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                points="189.998,101.089 99.998,22.539 55.088,61.699 55.088,41.379 37.178,41.379 37.178,77.369 9.998,101.089"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="Layer_1"></g>
    </SvgIcon>
  )
}

export default HomeIcon
